export default __webpack_public_path__ + "static/media/notes.130671fa.svg";